var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SettingsSectionDetails"},[_c('SettingsSectionTitle',[_vm._v(_vm._s(_vm.title))]),_c('SettingsSectionDescription',[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }